import { AuthContext, ProfileContext } from "../../Context";
import {
  Header,
  Footer,
  PersonalVerificationAlert,
} from "../../Components/Common";

import React, { Fragment, useContext } from "react";

const MainLayout = ({ children }: any) => {
  const { token } = useContext(AuthContext);
  const { profile } = useContext(ProfileContext);

  // ========================================================================

  return (
    <Fragment>
      <main className="flex-grow-1 w-100">
        <Header />

        {token ? (
          !profile.personalVerification ? (
            <PersonalVerificationAlert />
          ) : null
        ) : null}
        {children}
        <Footer />
      </main>
    </Fragment>
  );
};

export default MainLayout;
